    <div class="arbx-clear-filter my-2">
      <i class="fa-solid fa-filter"></i>
      المسارات
    </div>
    <div class="over-flow-y">
<div role="button" class="{{
    type._id == currentSurvey._id
      ? 'survey-active'
      : 'show-count d-flex align-items-center justify-content-between color-grey survery-hover my-2'}}"
  *ngFor="let type of data">
  <div class="d-flex justify-content-between w-100 gap-2">
    <div class="d-flex">
      <span class="survery-count-name" (click)="changeCurrentSurvey(type)">
        {{ type.name }} <br> ({{ type.tag.arabic }})
      </span>
    </div>
    <div class="d-flex align-items-center">
      <span (click)="changeCurrentSurvey(type)" class="survey-count">{{
        type.surveys.length
        }}</span>
    </div>
  </div>
  <span class="question-count gap-1" *ngIf="hasPermission('SURVEY_TYPE','u') || hasPermission('SURVEY_TYPE','d')">
    <p-menu #menu
      [model]="(type._id == '65b4e2d8cab47de5ee5a2415' || type._id == '6692508954a2ffed9d79163f' || type._id == '66f2c9f0788bfe7c2ebd8269' ) ? updateOnlyMenuItem : hasCreatedBy(type)"
      [popup]="true" appendTo="body"></p-menu>
    <p-button class="v4-ui" styleClass="p-button-rounded p-button-text" (onClick)="openTypeMenu(menu, $event, type)"
      icon="pi pi-ellipsis-v"></p-button>
  </span>
</div>
</div>
<div *ngIf="hasPermission('SURVEY_TYPE','c')" (click)="openCreateModal = true" role="button" class="input-option mt-2">
  <i class="pi pi-plus-circle mx-2"></i>{{ "Add type" | translator }}
</div>

<!-- Confirm Modal -->
<!-- <p-confirmDialog [style]="{margin: '0rem 1rem'}"></p-confirmDialog> -->

<!-- Update Data Modal -->
<p-dialog [blockScroll]="true" [draggable]="false" header="Header" [(visible)]="updateModal"
  [style]="{ margin: '0rem 1rem' }">
  <ng-template pTemplate="header">
    <span class="text-xl font-bold">{{
      "Update survey type" | translator
      }}</span>
  </ng-template>
  <app-dynamic-form *ngIf="updateModal" [questions]="updateQuestions"
    (sendData)="UpdateData($event)"></app-dynamic-form>
</p-dialog>

<!-- Create new Modal -->
<p-dialog [blockScroll]="true" [draggable]="false" header="Header" [(visible)]="openCreateModal"
  [style]="{ margin: '0rem 1rem', width: '95vw', maxWidth: '1000px' }">
  <ng-template pTemplate="header">
    <span class="text-xl font-bold">{{ "Create a type" | translator }}</span>
  </ng-template>
  <app-dynamic-form [questions]="questions" (sendData)="receiveData($event)"></app-dynamic-form>
</p-dialog>

<p-dialog [blockScroll]="true" [draggable]="false" header="Header" [(visible)]="openInfoModal"
  [style]="{ margin: '0rem 1rem', width: '45vw', maxWidth: '1000px' }">
  <ng-template pTemplate="header">
    <span class="text-xl font-bold">{{ "Created By Info" | translator }}</span>
  </ng-template>
  <div class="d-flex gap-1">
    <div>
      <h5 class="medium-h">{{ "Created By Name" | translator }}</h5>
      <input
        type="text"
        [value]="getName(createdInfo?.createdBy?.name)"
        class="p-inputtext"
        [disabled]="true"
      />
    </div>
    <div>
      <h5 class="medium-h">{{ "Created By Email" | translator }}</h5>
      <input
        type="text"
        [value]="createdInfo?.createdBy?.email"
        class="p-inputtext"
        [disabled]="true"
      />
    </div>
    <div>
      <h5 class="medium-h">{{ "Created Time" | translator }}</h5>
      <input
        type="text"
        [value]="createdInfo?.createdAt | date: 'medium'"
        class="p-inputtext"
        [disabled]="true"
      />
    </div>
  </div>
</p-dialog>